import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import { useNavigate } from 'react-router-dom';

// Import all dashboard components
import OrgAdminDashboard from './dashboards/OrgAdminDashboard';
import DeputyCeoDashboard from './dashboards/DeputyCeoDashboard';
import DeptManagerDashboard from './dashboards/DeptManagerDashboard';
import TeamManagerDashboard from './dashboards/TeamManagerDashboard';
import EmployeeDashboard from './dashboards/EmployeeDashboard';

const Dashboard = () => {
  const { currentUser, loading: authLoading, forceRefreshCurrentUser } = useAuth();
  const { tasks = [], projects = [], users = [], notifications = [], departments = [], teams = [], loading: dataLoading } = useData();
  const navigate = useNavigate();

  // Force re-render when user role changes
  const [forceUpdate, setForceUpdate] = useState(0);
  
  // State for active tab
  const [activeTab, setActiveTab] = useState('management');
  
  useEffect(() => {
    if (currentUser?.role) {
      setForceUpdate(prev => prev + 1);
    }
  }, [currentUser?.role]);

  // Wait for both auth and data to be loaded
  if (authLoading || dataLoading || !currentUser?.role) {
    // Show more detailed loading info
    let loadingMessage = 'טוען...';
    if (authLoading) loadingMessage = 'טוען פרטי משתמש...';
    else if (dataLoading) loadingMessage = 'טוען נתונים...';
    else if (!currentUser?.role) loadingMessage = 'מחכה לפרטי תפקיד...';
    
    return (
      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 md:h-32 md:w-32 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 text-sm md:text-base">{loadingMessage}</p>
          <p className="text-xs md:text-sm text-gray-400 mt-2">
            תפקיד: {currentUser?.role || 'לא נטען'}
          </p>
        </div>
      </div>
    );
  }

  // Render dashboard based on role
  const renderDashboard = () => {
    switch (currentUser.role) {
      case 'org_admin':
      case 'ceo':
        return <OrgAdminDashboard activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'deputy_ceo':
        return <DeputyCeoDashboard activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'dept_manager':
        return <DeptManagerDashboard activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'team_manager':
        return <TeamManagerDashboard activeTab={activeTab} setActiveTab={setActiveTab} />;
      case 'employee':
        return <EmployeeDashboard activeTab={activeTab} setActiveTab={setActiveTab} />;
      default:
        return <EmployeeDashboard activeTab={activeTab} setActiveTab={setActiveTab} />;
    }
  };

  return (
    <>
      {renderDashboard()}
      {/* Force re-render when role changes */}
      <div key={forceUpdate} style={{ display: 'none' }} />
    </>
  );
};

export default Dashboard;